import { i18n as getI18n } from '@monogrid/vue-boost/i18n'
import { computed, inject } from 'vue'
import { Locale } from 'vue-i18n'

import { countryInjectionKey } from '@/App.vue'

// export const BASE_URL = 'https://www.acquadiparma.com/holiday-season-2023.html'
export const BASE_URL = {
  domain: 'https://www.acquadiparma.com',
  path: 'holiday-season-2023.html'
}

export function useHostURL () {
  const i18n = getI18n()
  const country = inject(countryInjectionKey)
  const getLocalizationPath = (locale: Locale = i18n.locale.value) => (
    country.value.code === 'default'
      ? `default/${locale}`
      : `${locale}/${country.value.code}`
  )

  return {
    home: computed(() => `${BASE_URL.domain}/${getLocalizationPath()}`),
    countries: computed(() => `${BASE_URL.domain}/countries`),
    login: computed(() => country.value.code === 'default' ? undefined : `${BASE_URL.domain}/${getLocalizationPath()}/login`),
    cart: computed(() => country.value.code === 'default' ? undefined : `${BASE_URL.domain}/${getLocalizationPath()}/cart`),
    getLocalizedURL: (locale: Locale, path?: string) => `${BASE_URL.domain}/${getLocalizationPath(locale)}${path || ''}/${BASE_URL.path}`
  }
}
